import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class UsefulLinkComponent extends Component {
  @service store;

  @tracked isDisabled = true;
  editableInputElementContainer = null;
  tippyInstance = null;

  @action
  focusElement(e) {
    e.focus();
  }

  @action
  isUrl(text) {
    return text.match(/^(https:\/\/)/);
  }

  @action
  onEnter() {
    if (
      this.args.item.title &&
      this.args.item.url &&
      this.isUrl(this.args.item.url)
    )
      this.args.item.save();
  }

  @action
  registerElement(e) {
    this.editableInputElementContainer = e;
  }

  @action
  handleInputPaste(e) {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('Text');
    if (this.isUrl(pastedData)) {
      this.args.item.url = pastedData;
    }
  }

  @action
  handleClickOutside() {
    if (
      this.args.item.title &&
      this.args.item.url &&
      this.isUrl(this.args.item.url)
    )
      this.args.item.save();
    else this.deleteRecord();
  }

  @action
  deleteRecord() {
    this.args.item.deleteRecord();
  }

  @action
  handleUnlink() {
    this.args.item.destroyRecord();
  }

  @action
  enableField() {
    this.editableInputElementContainer.disabled = false;
  }

  @action
  disableField() {
    this.editableInputElementContainer.disabled = true;
  }

  @action
  handleEdit() {
    if (this.args.handleEdit) {
      this.args.handleEdit(this.args.item);
      this.tippyInstance.hide();
      return;
    }
    this.isDisabled = false;
    this.enableField();
    this.editableInputElementContainer.focus();
  }

  @action
  resetDisabled() {
    this.isDisabled = true;
  }

  @action
  resetTooltip() {
    this.resetDisabled();
    this.disableField();
    if (!(this.args.item.isDestroyed || this.args.item.isDestroying)) {
      this.args.item.rollbackAttributes();
    }
  }

  @action
  handleUpdate() {
    if (!this.isUrl(this.args.item.url)) return;
    this.args.item.save();
    this.resetDisabled();
    this.disableField();
  }

  @action
  onTooltipHide() {
    this.resetTooltip();
  }

  @action
  onUntrigger() {
    // console.log('onUntrigger', instance, event);
  }

  @action
  onBeforeUpdate() {
    // console.log('onBeforeUpdate', instance, partialProps);
  }

  @action
  onTooltipCreate(instance) {
    this.tippyInstance = instance;
  }

  @action
  handleTitleChange(event) {
    this.args.item.title = event.target.value;
  }

  @action
  handleUrlChange(event) {
    this.args.item.url = event.target.value;
  }
}
